import React, { useContext } from 'react';
import Alert from 'react-bootstrap/Alert';
import { ErrorContext } from 'contexts';

/*
Context is used for singleton behaviour 
For example api call will remove alert and display new alert
*/
const Error = ({ message, error }) => {
  const { state, dispatch } = useContext(ErrorContext);
  if (!state.showError) return null;
  return (
    //  TODO: move style to class
    <Alert
      variant="danger"
      onClose={() => dispatch({ type: 'removeError' })}
      dismissible
      style={{ position: 'fixed', top: '0', width: '100%' }}
    >
      <Alert.Heading>{message}</Alert.Heading>
    </Alert>
  );
};

export { Error };
